import { useState, useRef, useCallback, useEffect } from 'react';

function useEditablePill({
  filter,
  controller,
  readOnly,
  focusOnWipInputRef,
  isFilterEmpty
}) {
  const [viewMode, setViewMode] = useState(true);
  const [shouldFocusOnPillWrapper, setShouldFocusOnPillWrapper] = useState(false);
  const pillWrapperRef = useRef(null);
  const [populateInputOnEdit, setPopulateInputOnEdit] = useState(false);
  const handleChangeViewMode = useCallback(
    (event, shouldFocusOnPillWrapperOverride) => {
      event == null ? void 0 : event.stopPropagation();
      if (readOnly) {
        return;
      }
      setShouldFocusOnPillWrapper(shouldFocusOnPillWrapperOverride != null ? shouldFocusOnPillWrapperOverride : !viewMode);
      setViewMode(!viewMode);
    },
    [readOnly, viewMode]
  );
  useEffect(() => {
    var _a;
    if (shouldFocusOnPillWrapper) {
      (_a = pillWrapperRef.current) == null ? void 0 : _a.focus();
      setShouldFocusOnPillWrapper(false);
    }
  }, [shouldFocusOnPillWrapper]);
  useEffect(() => {
    if (filter.forceEdit && viewMode) {
      setViewMode(false);
      controller.updateFilter(filter, { forceEdit: void 0 });
    }
  }, [filter, controller, viewMode]);
  useEffect(() => {
    if (viewMode) {
      setPopulateInputOnEdit((prevValue) => prevValue ? false : prevValue);
    }
  }, [viewMode]);
  useEffect(() => {
    if (viewMode && !readOnly && (isFilterEmpty == null ? void 0 : isFilterEmpty(filter))) {
      controller.removeFilter(filter);
      setTimeout(() => focusOnWipInputRef == null ? void 0 : focusOnWipInputRef());
    }
  }, [controller, filter, focusOnWipInputRef, readOnly, viewMode, isFilterEmpty]);
  const handlePillClick = useCallback(
    (e) => {
      e.stopPropagation();
      setPopulateInputOnEdit(true);
      handleChangeViewMode();
    },
    [handleChangeViewMode]
  );
  const handlePillKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        setPopulateInputOnEdit(true);
        handleChangeViewMode();
      }
    },
    [handleChangeViewMode]
  );
  return {
    viewMode,
    pillWrapperRef,
    populateInputOnEdit,
    handleChangeViewMode,
    handlePillClick,
    handlePillKeyDown
  };
}

export { useEditablePill };
//# sourceMappingURL=useEditablePill.js.map
